module.exports = __webpack_public_path__ + "static/media/proptree_logo_icon.4a4ec961.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/proptree_logo_icon.svg
// module id = 523
// module chunks = 0